<template>
  <section class="section section_bg first_page">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
  <div class="mobile_div  section_header d-flex justify-content-center" v-if="is_load">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link tag="a" to="/works" >Портфолио</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ category.name}}</li>
      </ol>
    </nav>
  </div>

    <div class="mobile_div section_header portfolio_list category_portfolio_tags_list tags_list_block" v-if="is_load">
      <div class="row col-md-12 mt-3 d-flex justify-content-center">
        <p><button   class="btn  ml-2 mr-2"   :class="{ 'tag_not_active': !(current_portfolio_tag && current_portfolio_tag=='all_works_tag'),'tag_active': (current_portfolio_tag && current_portfolio_tag=='all_works_tag') }"     @click="openPortfolioTag('all_works_tag')">
          все работы
        </button></p>
        <p v-if="tags.length>0" v-for="(tag,tag_key) in tags" :key="tag_key"  class="">

          <button   class="btn ml-2 mr-2" :class="{ 'tag_not_active': !(tag.tag && current_portfolio_tag && current_portfolio_tag==tag.tag),'tag_active': (tag.tag && current_portfolio_tag && current_portfolio_tag==tag.tag) }"     @click="openPortfolioTag(tag.tag)">
            {{ tag.title}}
          </button>&nbsp;&nbsp;
        </p>
      </div>
    </div>


    <div class="mobile_div no-gutters row justify-content-center" v-if="is_load">





      <div class="col-12  col-md-4 col-sm-6   "   v-if="(current_portfolio_tag && work.tags && work.tags.tags && work.tags.tags.includes(current_portfolio_tag)) || current_portfolio_tag=='all_works_tag'"  v-for="(work,work_index) in works" :key="work_index">
        <div class="card card-work portfolio_block_work section_header nocenter">
        <router-link  tag="a"
                      :to="{name: 'user_page_one_portfolio', params: { user_id: work.user.last_id,work_id:work.last_id }}"><v-lazy-image class="card-img-top" :src="work.image" alt="Card image cap"/></router-link>

        <div class="card-body">
          <h5 class="card-title"><router-link  tag="a"
                                                               :to="{name: 'user_page_one_portfolio', params: { user_id: work.user.last_id,work_id:work.last_id }}">{{ work.name}}</router-link></h5>
          <p class="card-text"> <router-link  tag="a"
                                                               :to="{name: 'works_in_category', params: { category_id: work.category_id,work_id:work.last_id }}">{{ work.category.name }}</router-link></p>
          <p class="card-text"> </p>
          <div class="d-flex align-items-center">
            <v-lazy-image :src="image_url+work.user.avatar" alt="Avatar" class="rounded-circle mr-2" style="width:50px; height:50px;" />
            <p class="card-text mb-0"><router-link  tag="a"
                                                    :to="{name: 'user_page_main', params: { user_id: work.user.last_id }}">{{ work.user.name}}</router-link></p>
          </div>
        </div>
        </div>
      </div>







    </div>
  </section>
</template>

<script>

import Api from "@/models/Api";
import Vue from "vue";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import VLazyImage from "v-lazy-image/v2";



var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {LoadingBlock,VLazyImage},
  data() {
    return {
     "category":null,
     "works":[],
      "tags":[],
      "current_portfolio_tag":"all_works_tag",
     "is_load":false,
      "image_url":"",
    }
  },
  mounted() {
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;
  var category_id=this.$route.params.category_id;
  var app=this;
  Api.loadAboutWorks_in_cat(category_id,function(data){

    app.tags=data.tags;
    app.current_portfolio_tag="all_works_tag";
    app.category=data.category;
    app.works=data.works;
    app.is_load=true;
  },function(){
    app.$router.push({name:'404'});
  })
  },
  methods: {
    openPortfolioTag(tag){
      var app=this;
      app.current_portfolio_tag=tag;
      return false;

    },





  }
};
</script>
